module.exports = __webpack_public_path__ + "static/img/HR_back.c820990.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/HR_back.jpg?20181011
// module id = imYC
// module chunks = 1